/* eslint-disable no-restricted-imports */
import { LoadingButton } from '@mui/lab';

import { useModifiedStyleForWeb } from '@savvy/deprecated-shared/theme';

import type { XLoadingButtonProps } from './types';

export function XLoadingButton(props: XLoadingButtonProps) {
  const style = useModifiedStyleForWeb(props.style);
  return <LoadingButton {...props} style={style} />;
}
